import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MoonIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const MoonIcon: React.FC<MoonIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      {/* <Path
        d="M14 8.5A6 6 0 0 1 7.5 2 6 6 0 1 0 14 8.5z"
        fill={colors[color]}
        stroke={colors[color]}
        strokeWidth={1.5}
        strokeLinejoin="round"
      /> */}
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7.43816L14.8719 8.73706C14.525 12.2535 11.5602 15 7.95287 15C4.11291 15 1 11.8871 1 8.04717C1 4.44017 3.74607 1.47551 7.26215 1.12827L8.56103 1L8.04629 2.19942C7.81942 2.72805 7.6934 3.31099 7.6934 3.92536C7.6934 6.34479 9.65475 8.30614 12.0742 8.30614C12.6888 8.30614 13.2719 8.18004 13.8006 7.95304L15 7.43816ZM13.087 9.76148C12.7576 9.81829 12.4192 9.84786 12.0742 9.84786C8.80328 9.84786 6.15167 7.19627 6.15167 3.92536C6.15167 3.58062 6.1812 3.24243 6.23793 2.91329C4.09023 3.63035 2.54172 5.65827 2.54172 8.04717C2.54172 11.0356 4.96437 13.4583 7.95287 13.4583C10.342 13.4583 12.3701 11.9095 13.087 9.76148Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

MoonIcon.displayName = 'MoonIcon';

export { MoonIcon };
